<script>
export default {
    name: 'ChartingFavoriteColorPicker',
    props: {
        value: { type: String, default: '#0ea5e9' },
        label: { type: String, default: 'Color de la carpeta' }
    }
};
</script>

<template>
    <label class="charting-favorite-color-picker" :title="label">
        <span class="charting-favorite-color-picker__swatch" :style="{ backgroundColor: value }" aria-hidden="true"></span>
        <input type="color" :value="value" :aria-label="label" @input="$emit('input', $event.target.value)" />
    </label>
</template>

<style scoped>
.charting-favorite-color-picker {
    position: relative;
    display: inline-flex;
    box-sizing: border-box;
    flex-shrink: 0;
    width: 2.875rem;
    height: 2.875rem;
    padding: 5px;
    border: 1px solid var(--p-surface-400, #94a3b8);
    border-radius: 0.75rem;
    background: var(--charting-b-panel-bg-strong, #fff);
    cursor: pointer;
}
.charting-favorite-color-picker__swatch {
    width: 100%;
    height: 100%;
    border-radius: 0.4rem;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
}
/* Keep the native accessible color dialog, without browser-specific swatch edges. */
.charting-favorite-color-picker input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    opacity: 0;
    cursor: pointer;
}
.charting-favorite-color-picker:hover { border-color: var(--brand-primary, #00add9); }
.charting-favorite-color-picker:focus-within {
    outline: 2px solid var(--brand-primary, #00add9);
    outline-offset: 3px;
}
</style>
